interface BRLDPatternProps {
  variant?: 'light' | 'dark' | 'subtle';
  opacity?: number;
  className?: string;
  size?: number; // Tamanho da célula da grade em pixels
}

/**
 * Componente de background pattern - Grade simples e sutil usando CSS
 */
export function BRLDPattern({ 
  variant = 'subtle', 
  opacity = 0.03,
  className = '',
  size = 24
}: BRLDPatternProps) {
  // Cores baseadas no contexto
  const colors = {
    light: '#808080', // Cinza neutro
    dark: 'rgba(255, 255, 255, 0.1)',
    subtle: '#808080' // Cinza neutro
  };

  const color = colors[variant];

  return (
    <div 
      className={`absolute inset-0 pointer-events-none ${className}`}
      style={{
        opacity,
        backgroundImage: `linear-gradient(to right, ${color} 1px, transparent 1px), linear-gradient(to bottom, ${color} 1px, transparent 1px)`,
        backgroundSize: `${size}px ${size}px`
      }}
      aria-hidden="true"
    />
  );
}

/**
 * Variante minimalista - grade mais espaçada
 */
export function BRLDPatternMinimal({ 
  variant = 'subtle', 
  opacity = 0.03,
  className = '',
  size = 32
}: BRLDPatternProps) {
  const colors = {
    light: '#808080',
    dark: 'rgba(255, 255, 255, 0.08)',
    subtle: '#808080'
  };

  const color = colors[variant];

  return (
    <div 
      className={`absolute inset-0 pointer-events-none ${className}`}
      style={{
        opacity,
        backgroundImage: `linear-gradient(to right, ${color} 1px, transparent 1px), linear-gradient(to bottom, ${color} 1px, transparent 1px)`,
        backgroundSize: `${size}px ${size}px`
      }}
      aria-hidden="true"
    />
  );
}
